// В милисекундах
export const PRELOADER_SHOW_TIME = 1000;
